import { render } from "./ServicesView.vue?vue&type=template&id=a1b4c10e"
import script from "./ServicesView.vue?vue&type=script&lang=js"
export * from "./ServicesView.vue?vue&type=script&lang=js"

import "./ServicesView.vue?vue&type=style&index=0&id=a1b4c10e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__